import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { productUrl, sellerUrl } from "../../util/url";

function MoreProductsOverlay({ seller }) {
  return (
    <Link to={sellerUrl(seller)}>
      <div className="more-products-overlay">더보기</div>
    </Link>
  );
}

MoreProductsOverlay.propTypes = {
  seller: PropTypes.object.isRequired,
};

export default function SellerCardGridProducts({ gridProducts, seller }) {
  return (
    <div className="grid-products">
      {Array(4)
        .fill(0)
        .map((_, idx) => {
          const product = gridProducts[idx];
          if (!product) return <div className="grid-product" key={idx}></div>;
          const showOverlay = idx === 3;
          return (
            <div className="grid-product" key={product.id}>
              <Link to={productUrl(product)} className="product-thumbnail">
                <img
                  src={
                    product.resizedSmallImages && product.resizedSmallImages[0]
                  }
                  alt={product.title}
                  className="product-image"
                />
              </Link>
              {showOverlay && <MoreProductsOverlay seller={seller} />}
            </div>
          );
        })}
    </div>
  );
}

SellerCardGridProducts.propTypes = {
  gridProducts: PropTypes.array.isRequired,
  seller: PropTypes.object.isRequired,
};
